import { MenuItem } from "./menu.types";

export const menuItems1: MenuItem[] = [
  { id: 1, label: "Dashboard", icon: "las la-home", to: "/", permissionId: 1 },
  {
    id: 11,
    label: "National Cartography",
    icon: "las la-map-marked-alt",
    to: "/national-cartography",
    permissionId: 14,
  },
  {
    id: 2,
    label: "Roles",
    icon: "las la-check-circle",
    to: "/role",
    permissionId: 5,
  },
  {
    id: 4,
    label: "Matching",
    icon: "las la-project-diagram",
    to: "/rfqs",
    permissionId: 11,
  },
  {
    id: 9,
    label: "OEM profile",
    icon: "las la-user-tie",
    to: "/oem-profile",
    permissionId: 9,
  },
  {
    id: 10,
    label: "Supplier profile",
    icon: "las la-user",
    to: "/profileSupplier",
    permissionId: 10,
  },
];
